import type { Room } from "../../../interfaces/interfaces";

export default [
  {
    name: "SH62",
    id: "22f2e914-3b53-4eb6-9bcd-8c6e1f0e53ca",
  },
  {
    name: "SH63",
    id: "1178d2ab-6ea0-4ee3-a98f-697ea0223ce3",
  },
  {
    name: "SH407",
    id: "38597f22-e123-4eac-8054-df4f50ba15fb",
  },
  {
    name: "SH408",
    id: "d17497a0-44a9-4b65-bb0f-540258ddd818",
  },
  {
    name: "SH603",
    id: "3dceb5a4-18ce-4697-a779-6dfc59a70cd8",
  },
  {
    name: "SH604",
    id: "00ee5982-882b-46fa-aa5d-2e5004fb3293",
  },
  {
    name: "SH605",
    id: "58b85357-10b8-4331-bc75-89a99450aff3",
  },
  {
    name: "Byttan",
    id: "6c84eb3e-6190-476a-9fa7-5b5d3ba14a86",
  },
] as Room[];
